export default {
  GLOBAL_SET: 'GLOBAL_SET',
};
